import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Helper to get auth headers
const getAuthHeaders = () => {
    const token = localStorage.getItem('adminToken');
    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
};

/**
 * Check mobile money account
 */
export const checkMobileMoneyAccount = async (phoneNumber, provider) => {
    try {
        const response = await axios.post(
            `${BACKEND_URL}/api/admin/disbursements/check-account`,
            {
                phone_number: phoneNumber,
                provider: provider
            },
            { headers: getAuthHeaders() }
        );

        return {
            success: true,
            data: response.data.data
        };
    } catch (error) {
        console.error('Check account error:', error);
        return {
            success: false,
            message: error.response?.data?.detail || 'Failed to check account'
        };
    }
};

/**
 * Initiate disbursement to driver
 */
export const initiateDisbursement = async (driverId, amount, provider, notes = null) => {
    try {
        const response = await axios.post(
            `${BACKEND_URL}/api/admin/disbursements/initiate`,
            {
                driver_id: driverId,
                amount: amount,
                provider: provider,
                notes: notes
            },
            { headers: getAuthHeaders() }
        );

        return {
            success: true,
            data: response.data.data,
            message: response.data.message
        };
    } catch (error) {
        console.error('Initiate disbursement error:', error);
        return {
            success: false,
            message: error.response?.data?.detail || 'Failed to initiate disbursement'
        };
    }
};

/**
 * Get disbursement history for a driver
 */
export const getDriverDisbursements = async (driverId, limit = 50) => {
    try {
        const response = await axios.get(
            `${BACKEND_URL}/api/admin/disbursements/driver/${driverId}?limit=${limit}`,
            { headers: getAuthHeaders() }
        );

        return {
            success: true,
            data: response.data.data
        };
    } catch (error) {
        console.error('Get driver disbursements error:', error);
        return {
            success: false,
            message: error.response?.data?.detail || 'Failed to fetch disbursements'
        };
    }
};

/**
 * Get all disbursements
 */
export const getAllDisbursements = async (filters = {}) => {
    try {
        const params = new URLSearchParams();
        
        if (filters.status) params.append('status', filters.status);
        if (filters.provider) params.append('provider', filters.provider);
        if (filters.limit) params.append('limit', filters.limit);
        if (filters.skip) params.append('skip', filters.skip);

        const response = await axios.get(
            `${BACKEND_URL}/api/admin/disbursements?${params.toString()}`,
            { headers: getAuthHeaders() }
        );

        return {
            success: true,
            data: response.data.data
        };
    } catch (error) {
        console.error('Get all disbursements error:', error);
        return {
            success: false,
            message: error.response?.data?.detail || 'Failed to fetch disbursements'
        };
    }
};

/**
 * Check disbursement status
 */
export const checkDisbursementStatus = async (disbursementId) => {
    try {
        const response = await axios.get(
            `${BACKEND_URL}/api/admin/disbursements/${disbursementId}/status`,
            { headers: getAuthHeaders() }
        );

        return {
            success: true,
            data: response.data.data
        };
    } catch (error) {
        console.error('Check disbursement status error:', error);
        return {
            success: false,
            message: error.response?.data?.detail || 'Failed to check status'
        };
    }
};

/**
 * Get disbursement statistics
 */
export const getDisbursementStatistics = async (days = 30) => {
    try {
        const response = await axios.get(
            `${BACKEND_URL}/api/admin/disbursements/summary/statistics?days=${days}`,
            { headers: getAuthHeaders() }
        );

        return {
            success: true,
            data: response.data.data
        };
    } catch (error) {
        console.error('Get disbursement statistics error:', error);
        return {
            success: false,
            message: error.response?.data?.detail || 'Failed to fetch statistics'
        };
    }
};
